"use client";

import React, { useEffect, useRef, useState } from "react";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const metricsData = [{
  value: "450+",
  label: "Properties Sourced"
}, {
  value: "£12M+",
  label: "Returns Distributed"
}, {
  value: "1,850",
  label: "Families Housed"
}, {
  value: "10%",
  label: "Average Net Yield"
}];
export default function PerformanceMetrics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="116899" id="market-impact-stats" className="bg-background text-foreground py-24 px-4 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={`flex flex-col lg:flex-row w-full transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {metricsData.map((metric, i) => <div key={i} data-index={i} className="flex-1 flex flex-col items-center justify-center text-center py-12 lg:py-8 border-b lg:border-b-0 lg:border-r border-foreground/10 last:border-0">
              <span className="text-primary font-default font-bold text-6xl md:text-7xl tracking-tighter mb-4">
                {metric.value}
              </span>
              <span className="text-foreground/60 text-[12px] uppercase tracking-[0.2em] font-medium font-sans">
                {metric.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}